import Vue from "vue";
import store from "@/store";
import { getName } from "@/utils/computer";

export async function computerNotice(item) {
  if (
    store.state.settings.user.profile &&
    store.state.settings.user.profile.notifications &&
    store.state.settings.user.profile.notifications.computerAdd &&
    !store.getters["computer/singleComputer"](item.uid)
  ) {
    const name = getName(item);
    notify("New computer", `'${name}' was added.`, "success", 0);
  }
}

export function notify(title, text, type, duration, speed) {
  Vue.notify({
    group: "all",
    title: title || "",
    text: text || "",
    duration: duration || 10000,
    speed: speed || 200,
    type: type || "success",
  });
}
